<template>
  <div class="card">
    <div class="has-text-centered">
      <!-- Bouton Résultats du groupe -->
      <b-tooltip :label="$t('tooltip.results.group')" type="is-info">
        <button
          style="font-size:1.5em"
          @click="rendu('dashboard')"
          :class="this.button_renduDashBoard ? 'button is-focused' : 'button'"
        >
          <b-icon pack="fas" icon="users" size="is-small" />
        </button>
      </b-tooltip>
      {{ " " }}
      <!-- Bouton Résultats individuels -->
      <b-tooltip :label="$t('tooltip.results.individual')" type="is-info">
        <button
          style="font-size:1.5em"
          @click="rendu('liste')"
          :class="this.button_renduListe ? 'button is-focused' : 'button'"
        >
          <b-icon pack="fas" icon="user" size="is-small" />
        </button>
      </b-tooltip>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["button_renduDashBoard", "button_renduListe"])
  },
  methods: {
    rendu(el) {
      this.$store.commit("INSIGHT_BUTTON_DASHBOARD_ROUE", el);
    }
  }
};
</script>
